
const today = () => new Date()
const yesterday = () => new Date(today().setDate(today().getDate() - 1))
const tomorrow = () => new Date(today().setDate(today().getDate() + 1))
const firstDayLastMonth = () => new Date(new Date(today().setDate(1)).setMonth(today().getMonth() - 1))
const firstDay2LastMonth = () => new Date(new Date(today().setDate(1)).setMonth(today().getMonth() - 2))
const firstDayLast3Month = () => new Date(firstDayLastMonth().setMonth(firstDayLastMonth().getMonth() - 2))
const firstDayNextMonth = () => new Date(new Date(today().setDate(1)).setMonth(today().getMonth() + 1))
const firstDayNext2Months = () => new Date(new Date(today().setDate(1)).setMonth(today().getMonth() + 2))
const firstDayNext3Months = () => new Date(firstDayNextMonth().setMonth(firstDayNextMonth().getMonth() + 2))

const last2Days = new Date(yesterday().setDate(yesterday().getDate() - 1)),
    next2Days = new Date(tomorrow().setDate(tomorrow().getDate() + 1)),
    eightDays = new Date(today().setDate(today().getDate() - 8)),
    next8Days = new Date(today().setDate(today().getDate() + 8)),
    nineDays = new Date(today().setDate(today().getDate() - 9)),
    next9Days = new Date(today().setDate(today().getDate() + 9)),
    sixteenDays = new Date(today().setDate(today().getDate() - 16)),
    next16Days = new Date(today().setDate(today().getDate() + 16)),
    nextMonth = new Date(today().setMonth(today().getMonth() + 1)),
    next3Month = new Date(today().setMonth(today().getMonth() + 3)),
    next6Month = new Date(today().setMonth(today().getMonth() + 6)),
    lastMonth = new Date(today().setMonth(today().getMonth() - 1)),
    last3Month = new Date(today().setMonth(today().getMonth() - 3)),
    last6Month = new Date(today().setMonth(today().getMonth() - 6)),
    //lastDayLastMonth = new Date(today().setDate(0)),
    lastDay2LastMonth = firstDayLastMonth().setDate(0),
    nextDay2NextMonth = firstDayNextMonth().setDate(0),
    lastDayLast4Month = new Date(firstDayLast3Month().setDate(firstDayLast3Month().getDate() - 1)),
    lastDayNext4Month = new Date(firstDayNext3Months().setDate(firstDayNext3Months().getDate() + 1)),
    firstDayLast6Month = new Date(firstDayLastMonth().setMonth(firstDayLastMonth().getMonth() - 5)),
    firstDayNext6Month = new Date(firstDayNextMonth().setMonth(firstDayNextMonth().getMonth() + 5)),
    nextYear = new Date(today().setYear(today().getFullYear() + 1)),
    lastYear = new Date(today().setYear(today().getFullYear() - 1)),
    firstDayYear =  new Date(`01-01-${today().getFullYear()}`),
    firstDayLastYear = new Date(`01-01-${today().getFullYear() - 1}`),
    lastDayLastYear = new Date(`12-31-${today().getFullYear() - 1}`),
    firstDayLast2Year = new Date(`01-01-${today().getFullYear() - 2}`),
    lastDayLast2Year = new Date(`12-31-${today().getFullYear() - 2}`),
    firstDayNextYear = new Date(`01-01-${today().getFullYear() + 1}`),
    lastDayNextYear = new Date(`12-31-${today().getFullYear() + 1}`),
    firstDayNext2Year = new Date(`01-01-${today().getFullYear() + 2}`),
    lastDayNext2Year = new Date(`12-31-${today().getFullYear() + 2}`)

const RANGES = {
    today: [today(), today()],
    todayPrev: [yesterday(), yesterday()],
    todayNext: [tomorrow(), tomorrow()],
    yesterday: [yesterday(), yesterday()],
    yesterdayPrev: [last2Days, last2Days],
    tomorrow: [tomorrow(), tomorrow()],
    tomorrowNext: [next2Days, next2Days],
    last7Days: [eightDays, yesterday()],
    last7DaysPrev: [sixteenDays, nineDays],
    next7Days: [next8Days, tomorrow()],
    next7DaysNext: [next16Days, next9Days],
    todayPrevMonth: [firstDayLastMonth(), today()],
    todayNextMonth: [firstDayNextMonth(), today()],
    lastMonth: [today(), lastMonth],
    lastMonthPrev: [firstDay2LastMonth(), lastDay2LastMonth],
    nextMonth: [today(), nextMonth],
    nextMonthNext: [firstDayNext2Months(), nextDay2NextMonth],
    last3Month: [today(), last3Month],
    last3MonthsPrev: [firstDayLast6Month, lastDayLast4Month],
    next3Month: [today(), next3Month],
    last6Month: [today(), last6Month],
    next6Month: [today(), next6Month],
    next3MonthsNext: [firstDayNext6Month, lastDayNext4Month],
    yearToDate: [firstDayYear, today()],
    yearToDatePrev: [firstDayLastYear, lastDayLastYear],
    lastYear: [today(), lastYear],
    lastYearPrev: [firstDayLast2Year, lastDayLast2Year],
    yearToDateNext: [firstDayNextYear, lastDayNextYear],
    nextYear: [today(), nextYear],
    nextYearNext: [firstDayNext2Year, lastDayNext2Year],
}

export const getDateRanges = range => {
    return RANGES[range] || [null, null]
}